import React from "react";
import ReactDOM from "react-dom";
import "./index.less";
import "animate.css";

import registerServiceWorker from "./registerServiceWorker";
import { HashRouter as Router, Switch } from "react-router-dom";
import { Route, Hi } from "react-router";
import { getWxLogin } from "./utils/wxLogin";
import { href, viewPort, getUrlParams } from "./utils/util";
import cookies from "js-cookie";
import routeConfig from "./routeConfig";
import { getLoginStatus } from "./service";
import hlInsight from "hl-track-sdk";
import Countly from "countly-sdk-web";
import hlEncryption from "./utils/jsencrypt/hlEncryption";

window.Countly = Countly;
const viewPortData = viewPort();

window.HLEncryption = new hlEncryption();
window.HLEncryption.getClientSecret();

// 埋点
hlInsight.init({
    app_key: "cca2159eb2d74cb8808320a8f691746a", // 接入项目key，由后台创建分配
    app_version: "", // 接入项目版本号，可以自由输入，按照发布版本
    os: "h5", // 数据采集端（web/ios/android/h5/wx）
    show_log:
        window.location.host.indexOf("www.hellogil.com") > -1 ? false : true, // 是否显示日志
    is_track_single_page: false, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会触发 pageview 事件
});
React.$hlInsight = hlInsight;
// window.hlInsight = hlInsight;
let app_stoken = "DI2M3CHTO1BEYETWU3ZG0M7B1OLLYERD_1900006621";
if (!viewPortData.isWeixin) {
    if (viewPortData.ios || viewPortData.iPhone || viewPortData.iPad) {
        if (window.webkit) {
            app_stoken = window.prompt("getAppToken", "");
        }
    } else {
        if (window.huilian && window.huilian.getAppToken) {
            app_stoken = window.huilian.getAppToken();
        }
    }
    if (app_stoken) {
        React.$hlInsight.login(
            app_stoken.indexOf("_") > -1 ? app_stoken.split("_")[1] : app_stoken
        );
    }
}

let currentPath = (window.location.hash || "").replace("#/", "/");
let currRoute = {};

// 防止安卓oppoR9系统版本为6.0的手机中缺失Array.from报错
Array.from = (function () {
    var toStr = Object.prototype.toString;
    // 判断是否为函数或方法
    var isCallable = function (fn) {
        return (
            typeof fn === "function" || toStr.call(fn) === "[object Function]"
        );
    };
    // 转换成整数
    var toInteger = function (value) {
        var number = Number(value);
        // isNaN 返回0
        if (isNaN(number)) {
            return 0;
        }
        // number为0 或者不是有限数字， 则返回 number
        if (number === 0 || !isFinite(number)) {
            return number;
        }
        // 如果以上条件不符，则返回如下，number 的绝对值向下去整，然后再确定下number 是正数还是负数
        return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    // 最大有效数字
    var maxSafeInteger = Math.pow(2, 53) - 1;
    // 返回一个有效数字
    var toLength = function (value) {
        var len = toInteger(value);
        return Math.min(Math.max(len, 0), maxSafeInteger);
    };
    // 若value为 set对象 则 转为数组
    var toItems = function (value) {
        // support set
        if (value.size > 0 && value.values) {
            let values = value.values();
            var it = values.next();
            var o = [];
            while (!it.done) {
                o.push(it.value);
                it = values.next();
            }
            return o;
        }
        return Object(value);
    };
    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
        var C = this;

        // arrayLike 为 undefined or null 则抛出异常
        if (arrayLike == null) {
            throw new TypeError(
                "Array.from requires an array-like object - not null or undefined"
            );
        }
        //
        var items = toItems(arrayLike);

        // 4. If mapfn is undefined, then let mapping be false.
        var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
        var T;
        if (typeof mapFn !== "undefined") {
            // 5. else
            // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
            if (!isCallable(mapFn)) {
                throw new TypeError(
                    "Array.from: when provided, the second argument must be a function"
                );
            }

            // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
            if (arguments.length > 2) {
                T = arguments[2];
            }
        }

        // 10. Let lenValue be Get(items, "length").
        // 11. Let len be ToLength(lenValue).
        var len = toLength(items.length);

        // 13. If IsConstructor(C) is true, then
        // 13. a. Let A be the result of calling the [[Construct]] internal method
        // of C with an argument list containing the single item len.
        // 14. a. Else, Let A be ArrayCreate(len).
        var A = isCallable(C) ? Object(new C(len)) : new Array(len);

        // 16. Let k be 0.
        var k = 0;
        // 17. Repeat, while k < len… (also steps a - h)
        var kValue;
        while (k < len) {
            kValue = items[k];
            if (mapFn) {
                A[k] =
                    typeof T === "undefined"
                        ? mapFn(kValue, k)
                        : mapFn.call(T, kValue, k);
            } else {
                A[k] = kValue;
            }
            k += 1;
        }
        // 18. Let putStatus be Put(A, "length", len, true).
        A.length = len;
        // 20. Return A.
        return A;
    };
})();

// if(new Date().getDate() == 4){
//     console.log(111111111)
//     document.getElementsByTagName('html')[0].style.cssText = "-webkit-filter: grayscale(100%); -moz-filter: grayscale(100%); -ms-filter: grayscale(100%); -o-filter: grayscale(100%); filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); _filter:none;";
// }

routeConfig.map((item) => {
    if (currentPath.indexOf(item.path) >= 0) {
        currRoute = item;
    }
});

let isHadLogin = false,
    isMustLogin = false;

// 包装
const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            const { title } = rest;
            document.title = title ? title : "远程慧联";
            return <Component {...props} />;
        }}
    />
);

class App extends React.Component {
    componentDidMount() {
        routeConfig.map((item) => {
            if (item.isLogin && currentPath === item.path) {
                isMustLogin = true;
            }
        });
        if (!isHadLogin && (isMustLogin || !currentPath)) {
            href("/login");
            return;
        } else if (!currentPath && isHadLogin) {
            href("/index");
            console.log(444444444444);
            return;
        }
    }
    render() {
        return (
            <Router>
                <Switch>
                    {routeConfig.map((item, index) => {
                        return (
                            <PrivateRoute
                                key={index}
                                path={item.path}
                                component={item.component}
                                title={item.title}
                            />
                        );
                    })}
                </Switch>
            </Router>
        );
    }
}

getWxLogin(currRoute).then(() => {
    getLoginStatus(currRoute).then(
        () => {
            isHadLogin = true;
            ReactDOM.render(<App />, document.getElementById("root"));
            registerServiceWorker();
        },
        () => {
            console.log(33333);
            ReactDOM.render(<App />, document.getElementById("root"));
            registerServiceWorker();
        }
    );
});

var hostname = window.location.hostname;
var app_key, url;
if (
    hostname === "hic-test.lvsehuilian.cn" ||
    hostname === "test.lvsehuilian.cn"
) {
    app_key = "a7c255ce40504cae1f6058411990d0c87f70a668";
    url = "https://countly-test.lvsehuilian.cn"; //'https://10.240.56.111'
} else {
    app_key = "04df0ce8ea6cc45dc48e6adf907e6077dc8b0ab4";
    url = "http://countly.hellogil.com:8001";
}

Countly.init({
    app_key: app_key,
    url: url,
});



// WEBPACK FOOTER //
// ./src/index.js